import { useEffect, useRef, useState } from "react";

const useIntersectionObserver = () => {
  const containerRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const container = containerRef.current;

    const handleIntersection = (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting || entry.intersectionRatio > 0) {
          setIsVisible(true);
          // Optionally continue observing
          // observer.unobserve(entry.target);
        }
      });
    };

    // Adjust threshold and rootMargin based on viewport
    const options = {
      threshold: window.innerWidth > 768 ? [0, 0.5] : [0],
      rootMargin: '-100px',
    };

    const observer = new IntersectionObserver(handleIntersection, options);

    if (container) {
      observer.observe(container);
    }

    return () => {
      if (container) {
        observer.unobserve(container);
      }
    };
  }, []);

  return [containerRef, isVisible];
};

export default useIntersectionObserver;
